import { DateTime } from "luxon";

// Function that will format dates to YYYY-MM-DD
export const formatDate = (unixTimestamp: string) => {
  const date = DateTime.fromSeconds(Number(unixTimestamp), { zone: "UTC" });
  return date.toFormat("yyyy-MM-dd");
};

//Function that will formate to dates to YYYY
export const formatDateWithTime = (unixTimestamp: string) => {
  const date = DateTime.fromSeconds(Number(unixTimestamp), { zone: "UTC" });
  return date.toFormat("yyyy-MM-dd_HHmmss");
};

export const getEpochTime = (date: string) => {
  return Math.floor(new Date(date).getTime()/1000.0);
};